import React from 'react';

const AndroidBadge = ({ onClick, style = {} }) => {
  return (
    <div
      onClick={onClick}
      style={{
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        width: '220px',
        height: '65px',
        backgroundColor: '#EAB308',
        border: '2px solid #EAB308',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        padding: '12px 16px',
        gap: '12px',
        marginBottom: "5px",
        ...style
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.05)';
        e.currentTarget.style.filter = 'brightness(1.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.filter = 'brightness(1)';
      }}
    >
      {/* Android Robot Head and APK Text */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '4px',
        flexShrink: 0
      }}>
        {/* Android Robot Head */}
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85a.637.637 0 0 0-.83.22l-1.88 3.24a11.43 11.43 0 0 0-8.94 0L5.65 5.67a.643.643 0 0 0-.87-.2c-.28.18-.37.54-.22.83L6.4 9.48C3.3 11.25 1.28 14.44 1 18h22c-.28-3.56-2.3-6.75-5.4-8.52zM7 15.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm10 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z" fill="#000000"/>
        </svg>
        {/* APK Text */}
        <div style={{
          fontSize: '12px',
          color: '#000000',
          fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
          fontWeight: '700',
          lineHeight: '1'
        }}>
          APK
        </div>
      </div>
      
      {/* Download Android APK Text */}
      <div style={{ flex: 1 }}>
        <div style={{
          fontSize: '12px',
          color: '#000000',
          fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
          fontWeight: '400',
          lineHeight: '1.2',
          marginBottom: '2px'
        }}>
          Download
        </div>
        <div style={{
          fontSize: '20px',
          color: '#000000',
          fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
          fontWeight: '700',
          lineHeight: '1.1'
        }}>
          Android APK
        </div>
      </div>
    </div>
  );
};

export default AndroidBadge;